/* eslint-disable */

import * as clientService from "./httpsClient";

export const getUsers = async (accessToken, params) => {
  const { page, limit, values } = params;
  let object = {
    page: page ? page : 0,
    limit: limit ? limit : 10,
  };
  if (values != undefined) {
    object.username = values.username;
  }

  try {
    return await clientService.getApi(`usermangement/users`, accessToken, object);
  } catch (error) {
    throw error;
  }
};

export const getUserManagers = async (accessToken, body) => {
  try {
    const domain = `usermangement/users/managers`;
    return await clientService.getApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getUserGroups = async (accessToken, body) => {
  const { id } = body;
  try {
    const domain = `usermangement/users/groups/${id}`;
    return await clientService.getApi(domain, accessToken);
  } catch (error) {
    throw error;
  }
};

export const getUserPermission = async (accessToken, body) => {
  const { id } = body;
  try {
    const domain = `usermangement/users/permissions/${id}`;
    return await clientService.getApi(domain, accessToken);
  } catch (error) {
    throw error;
  }
};

export const createUser = async (accessToken, body) => {
  try {
    const domain = `usermangement/users`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const deleteUser = async (accessToken, body) => {
  try {
    const domain = `usermangement/users`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const updateUser = async (accessToken, body) => {
  // const { id } = body
  try {
    const domain = `usermangement/users`;
    return await clientService.putApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};
